import { put, takeLatest } from 'redux-saga/effects'
import { saveDrain } from '../store/drain.actions'
import { DrainConstants } from '../store/drain.constants'

export function* setCommonFields() {
  yield put(saveDrain())
}

export function* setCommonFieldsSaga() {
  yield takeLatest(
    [
      DrainConstants.SET_ASSESSED_BY,
      DrainConstants.SET_ATTEMPTS,
      DrainConstants.SET_AUTHORIZATION,
      DrainConstants.SET_PROCEDURE_COMPLICATIONS,
      DrainConstants.SET_ROLE_PERFORMING,
      DrainConstants.SET_ROLE_PERFORMING_PNNV,
      DrainConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
      DrainConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
      DrainConstants.SET_RESPONSE,
      DrainConstants.SET_RESPONSE_PNNV,
      DrainConstants.SET_TIME,
      DrainConstants.SET_DATE,
      DrainConstants.SET_DATE_TIME,
    ],
    setCommonFields
  )
}
